export default function ResetAccount({ contentData, initError, initLoader }) {
  return <div>This is Reset Account page</div>;
}
